//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  headerText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Segoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  topGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  historyBtn: {
    border: "none",
    float: "right",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    cursor: "pointer",
    padding: "4px 8px",
    position: "relative",
    right:"-15%",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    "&:hover": {
      backgroundColor: "#0a72ba",
    },
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
  },
  filterBtn: {
    marginLeft: 20,
  },
  root: {
    flexGrow: 1,
    marginBottom: 20,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  filterCardDiv: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
    },
  },
  filterCardDivSub: {
    // position: 'relative',
    // left: '15%',
    "@media (max-width: 768px)": {
      left: 0,
    },
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: 600,
    zIndex: 100,
    marginBottom: 20,
  },
  filterCardGridContainer: {
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #0000004D",
    alignSelf: "center",
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: 24,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    border: " 1px solid #305698",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    marginTop: "5%",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#305698 !important",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698 !important",
    },
  },
  tableDiv: {
    marginTop: 20,
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  tableDownInResponsive: {
    marginBottom: 150,
  },
  cursorPointer: {
    cursor: "pointer",
  },
  displayNone: {
    display: "none",
  },
  cronJobBtnGrid: {
    alignItems: "center",
    textAlign: "right",
    alignSelf: "center",
  },
  cronJobBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 150,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  approveDiv: {
    backgroundColor: "green",
    width: "60%",
    textAlign: "center",
    color: "#fff",
    fontSize: 18,
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: 5,
    "@media (max-width: 1400px)": {
      width: "80%",
    },
  },
  declineDiv: {
    backgroundColor: "red",
    width: "60%",
    textAlign: "center",
    color: "#fff",
    fontSize: 18,
    fontWeight: "bold",
    cursor: "pointer",
    borderRadius: 5,
    "@media (max-width: 1400px)": {
      width: "80%",
    },
  },
  // Decline dialog
  dialogParentDiv: {
    padding: 25,
  },
  padding: {
    padding: "20px 0px",
  },
  parentText: {
    fontSize: 25,
  },
  parentTextIcon: {
    color: "#faae30",
    fontSize: 30,
  },
  subParentText: {
    color: "#595959",
    fontSize: 20,
  },
  dialogInput: {
    width: "100%",
    margin: "20px 0px",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    border: "2px solid #305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
  },
  proceedBtnGrid: {
    textAlign: "right",
  },
  proceedBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  exportBtn1: {
    color: "#fff",
    width: "120px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#0a72ba",
    border: "none",
    // marginLeft:"38%",

    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
  // CSVlink: {
  //   display: "none",
  // },
}));
